"use client";

import styles from "@/styles/cart/empty-cart.module.scss";
import Image from "next/image";
import { Button } from "react-vant";
import { useRouter } from "next/navigation";
import { useAppSelector } from '@/store/hooks';


export default function CartEmptyCart() {
  // 从Redux store获取用户状态
  const { hasLogin } = useAppSelector((state) => state.user);
  const router = useRouter();

  const handleViewOrder = () => {
    if (hasLogin) {
      router.push("/my-account/order/0");
    } else {
      router.push("/login?redirect=/my-account/order/0");
    }
  };

  return (
    <div className={styles["comp-cart-empty"]}>
      <Image
        width={164}
        height={93}
        alt={'cart-empty'}
        src={`${process.env.IMAGE_DOMAIN}/cart/cart-empty-banner.png`}
        className={styles['empty-cart-image']}
      ></Image>

      <div className={styles["empty-title"]}>Your Shopping cart is Empty! </div>
      <div className={styles["empty-desc"]}>
        Add products to your cart by clicking the <br />
        &apos;ADD TO CART&apos; button next to the items you <br />
        would like to purchase.
      </div>

      <Button
        round
        type="primary"
        style={{ fontWeight: "700", marginBottom: "14px" }}
        block
        onClick={handleViewOrder}
      >
        View Your Orders
      </Button>

      <Button
        round
        plain
        type="primary"
        style={{ fontWeight: "700" }}
        block
        onClick={() => (window.location.href = "/")}
      >
        Continue Shopping
      </Button>
    </div>
  );
}